<template>
  <v-container class="back" fluid fill-height pa-0>
    <v-layout v-if="getSidebarActive == 'service'" column pa-0 pt-0>

      <v-flex xs12 style="position: relative" pa-0>

        <v-layout ref="barWrapper" column fill-height style="position: relative" ma-0>

          <v-layout justify-space-between style="position: relative" ma-0 pl-3 pt-3>

            <v-tabs
              light     
              v-model="panel"
              height="40px"
              left
            >
              <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>
              <v-tab
                  class="font-weight-normal"    
                  v-for="(place, index) in getPlaces"
                  :key="index"
                  :data-testid="$options.name + '__' + place + '_tab__' + place"
                >
                <template slot="default">
                  <div class="tab_wrapper">
                    <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                      {{ $t(place) }} 
                    </div>
                  </div>
                </template>
              </v-tab>
            </v-tabs>

            <v-flex shrink >
              <v-layout v-if="checkPlace()" fill-height justify-space-around align-center px-2>
  
                <v-tooltip bottom color="secondary">
                  <v-btn icon flat v-if="$store.state.auth.user.level <= 1" 
                  :data-testid="$options.name + '__btn__' + 'onEdit'" 
                  @click="() => onEdit()" 
                      dark medium class="lighten-2 font-weight-medium" slot="activator" >
                    <svg-icon
                      :color="'primary'"
                      :name="'edit'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('change') }}</span>
                </v-tooltip>

              </v-layout>

            </v-flex>


          </v-layout>

                <scroll-area>

                  <template slot="body">

                      <v-layout v-for="(place, i) in getPlaces" :key="i" v-if="getPlaces[panel] == place" fill-height px-2 pt-2 ma-0>
  
                        <v-layout column fill-height v-if="place == 'main' && getFields" justify-start px-2>
                          
                          <v-layout shrink @click.stop="showMain = !showMain" justify-space-between px-1 mx-1>
                            <v-layout shrink justify-start align-center>
                              <span class="uppercase">
                                {{ $t('main') }}
                              </span>
                            </v-layout>
                            <v-btn 
                            :data-testid="$options.name + '__btn__' + 'main'" 
                            @click.stop="showMain = !showMain" flat x-small dark class="white" slot="activator">
                              <v-icon v-if="!showMain" color="accent">expand_less</v-icon>
                              <v-icon v-if="showMain" color="accent">expand_more</v-icon>
                            </v-btn>
                          </v-layout>

                          <v-layout v-show="showMain" shrink v-for="(field, index) in getFields" :key="[place] + field.name" v-if="field.value && field.show == 'true' && field.place == place && field.name != 'coordinates'" px-2>

                            <v-flex xs3 v-if="field.value && field.place == place && field.name != 'coordinates'" shrink px-0 pb-2>
                              
                              <v-text-field
                                :value="$t(field.name)"
                                light
                                auto-grow
                                single-line
                                flat
                                readonly
                                disabled
                                class="white"
                                persistent-hint
                                hide-details
                                :label="$t(field.name)"
                                color="grey"
                              >
                            
                              </v-text-field>

                            </v-flex>

                            <v-flex xs9 v-if="field.value && field.place == place && field.name != 'coordinates'" shrink px-0 pb-2>
                              
                              <v-text-field
                                :value="field.name == 'type' || field.name == 'condition_type' || field.name == 'location_type'? $t(field.value) : field.value"
                                light
                                auto-grow
                                single-line
                                flat
                                readonly
                                disabled
                                class="white"
                                persistent-hint
                                hide-details
                                :label="$t(field.name)"
                                color="accent"
                              >
                            
                              </v-text-field>

                            </v-flex>

                          </v-layout>

                          <v-layout shrink @click.stop="showFiles = !showFiles" justify-space-between px-1 mx-1>
                            <v-layout shrink justify-start align-center>
                              <span class="uppercase">
                                {{ $t('attached files') }}
                              </span>
                            </v-layout>
                            <v-btn 
                            :data-testid="$options.name + '__btn__' + 'attached files'" 
                            @click.stop="showFiles = !showFiles" flat x-small dark class="white" slot="activator">
                              <v-icon v-if="!showFiles" color="accent">expand_less</v-icon>
                              <v-icon v-if="showFiles" color="accent">expand_more</v-icon>
                            </v-btn>
                          </v-layout>

                          <v-flex xs12 v-show="showFiles">

                            <file-list
                              :files="getFiles"
                              :data="getData"
                              @upload="(payload) => onFileAdd(payload)"
                              @edit="onFileEdit"
                              @delete="(payload) => onFileDelete(payload)"
                            />

                          </v-flex>

                          <v-layout shrink @click.stop="showStat = !showStat" justify-space-between px-1 mx-1>
                            <v-layout shrink justify-start align-center>
                              <span class="uppercase">
                                {{ $t('statistics') }}
                              </span>
                            </v-layout>
                            <v-btn 
                            :data-testid="$options.name + '__btn__' + 'statistics'" 
                            @click.stop="showStat = !showStat" flat x-small dark class="white" slot="activator">
                              <v-icon v-if="!showStat" color="accent">expand_less</v-icon>
                              <v-icon v-if="showStat" color="accent">expand_more</v-icon>
                            </v-btn>
                          </v-layout>

                          <v-layout column v-show="showStat" fill-height justify-start>
                            <location-statistics
                              @select=""
                            />
                          </v-layout>

                        </v-layout>

                        <v-layout fill-height v-if="place == 'composition'" justify-start>
                          <composition-table
                            :update="updater"
                            :data="getData"
                            :devices="devices"
                            @select="(payload) => onDeviceSelect(payload)"
                          />
                        </v-layout>

                        <v-layout column v-if="place == 'configuration'" style="position: relative" fill-height>
                          <configuration 
                            ref="configuration"
                            :data="getData"
                          />
                        </v-layout>

                        <v-layout column v-if="place == 'settings'" style="position: relative" fill-height>
                          
                          <service-settings></service-settings>

                        </v-layout>

                        <v-layout column fill-height v-if="place == 'map/documents' && getData && !(getData.coordinates || getData.latitude)" justify-start>
                          <file-list
                            :files="getFiles"
                            :data="getData"
                            @upload="(payload) => onFileAdd(payload)"
                            @edit="onFileEdit"
                            @delete="(payload) => onFileDelete(payload)"
                          />
                        </v-layout>

                        <v-layout column v-show="place == 'params'" ref="inventory_bar_wrapper" style="position: relative" fill-height>
                          <equipment-table
                            :data="getData"
                            :editeble="false"
                            :updater="equipmentTableUpdateCounter"
                            @chart="(payload)=>{onChartSelect(payload)}"
                            @value="(payload)=>{rulesOpen(payload)}"
                          />
                        </v-layout>              

                      </v-layout>

                  </template>

                </scroll-area>

          <service-bar-edit
            v-if="checkPage('physical')"
            :open="getServiceBarEdit"
            :data="getData"
            :mode="serviceBarEditMode"
            @update="() => updateTree()"
            @close="() => onServiceEditClose()"
          />

          <device-bar
            v-if="checkPage('physical')"
            :open="getDeviceBarOpen"
            @update="(payload) => updateDevice(payload)"
            @load-devices="loadDevices"
            @close="() => onDeviceBarClose()"
          />

          

        </v-layout>

      </v-flex>

    </v-layout>

    <v-dialog v-model="dialog.chart.open" max-width="50%" v-if="dialog.chart.open">
      <chart-card
        v-if="dialog.chart.open"
        :data="measure"
        :equipment="getData"
        @close="() => {
          dialog.chart.open = false
        }"
      />
    </v-dialog>

    <v-dialog persistent v-model="dialog.rules.open" max-width="600px" v-if="dialog.rules.open">
      <rules-table
        :row="dialog.rules.row"
        :ref-id="getData && getData.ref_id"
        @close="() => {dialog.rules.open = false}"
        @updateMeasures="() => {equipmentTableUpdateCounter++}"
        @loadDevice="() => updateTree()"
        @polling="() => {$emit('polling')}"
      />
    </v-dialog>

    <v-dialog persistent v-model="dialog.edit.open" max-width="50%" v-if="dialog.edit.open">
      <module-update-card
        :data="dialog.edit.obj"
        @close="() => {
          dialog.edit.open = false
          dialog.edit.obj = null
        }"
        @update="(payload) => {
          updateTree()
        }"
      />
    </v-dialog>

    <v-dialog v-model="dialog.upload.show" max-width="50%" v-if="dialog.upload.show && getSidebarActive == 'service'">
      <form-file-import
        :newFiles="dialog.upload.files"
        :edit="filesEdit"
        :files="filesEdit ? getFiles : []"
        :activeObj="getData"
        @update="() => updateTree()"
        @close="onFileImportClose()"
        @delete="(payload) => onFileDelete(payload)"
      />
    </v-dialog>

    <v-layout v-if="getSidebarActive == 'device'"  column pa-0 pt-0>

      <v-flex xs12 style="position: relative" pa-0>

        <v-layout ref="barWrapper" column fill-height style="position: relative" ma-0>

          <device-bar
            :open="true"
            :sizeButton="false"
            noclose
            @update="(payload) => updateDevice(payload)"
            @load-devices="loadDevices"
          />

        </v-layout>

      </v-flex>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import Configuration from '@/nms/components/device-configuration/configuration/configuration.vue'
import ServiceBarEdit from '@/nms/pages/services/create-service-bar.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'
import fileList from '@/nms/components/partials/file-list.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import moduleUpdateCard from '@/nms/pages/device/module-update-card.vue'
import CompositionTable from '@/nms/pages/location/table/services-table.vue'
import equipmentTable from '@/nms/pages/equipment/equipment-table.vue'
import rulesTable from '@/nms/pages/equipment/rules-table.vue'
import chartCard from '@/nms/pages/equipment/chart-card.vue'
import LocationStatistics from '@/nms/pages/location/table/location-statistics.vue'
import ServiceSettings from '@/nms/pages/services/service-settings.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { mapGetters } from 'vuex'

// Типы
interface DeviceItem {
  $id?: string
  id?: string
  name?: string
  cls?: string
  type?: string
  template?: string
  _cmdb_?: boolean
  tree_view?: boolean
  children?: DeviceItem[]
  getLinks?: (options?: any) => Promise<DeviceItem[]>
  getParent?: () => Promise<DeviceItem>
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  items: Record<string, any>
  obj: Record<string, any>
}

interface DialogState {
  create: { show: boolean; files: any[] }
  update: { show: boolean; files: any[] }
  upload: { show: boolean; files: any[] }
  edit: { open: boolean; obj: any | null }
  chart: { open: boolean }
  preferences: { open: boolean; param: any | null }
  rules: { open: boolean; row: any | null }
}

interface BarState {
  service: {
    edit: { open: boolean }
    update: { open: boolean }
  }
  device: { open: boolean }
}

interface FileItem {
  id?: string
  data?: {
    description?: string
    [key: string]: any
  }
  [key: string]: any
}

interface ServicePageData {
  showMain: boolean
  showFiles: boolean
  showStat: boolean
  mapType: string
  panel: number
  connectionPlaces: string[]
  connectionsPanel: number
  location: Record<string, any>
  devices: DeviceItem[]
  crumbs: any[]
  meta: Record<string, any>
  obj: DeviceItem | null
  model: ModelData
  updater: boolean
  serviceBarEditMode: boolean
  bar: BarState
  files: FileItem[]
  filesEdit: boolean
  equipmentTableUpdateCounter: number
  measure: any | null
  dialog: DialogState
  showMap: boolean
}

interface ActiveDevice {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'SERVICE_PAGE',

  components: {
    scrollArea,
    Configuration,
    ServiceBarEdit,
    DeviceBar,
    fileList,
    FormFileImport,
    moduleUpdateCard,
    CompositionTable,
    equipmentTable,
    rulesTable,
    chartCard,
    LocationStatistics,
    ServiceSettings,
    svgIcon,
  },

  props: {},

  data(): ServicePageData {
    return {
      showMain: true,
      showFiles: false,
      showStat: false,
      mapType: 'OL',
      panel: 0,
      connectionPlaces: ['connections', 'channels'],
      connectionsPanel: 0,
      location: {},
      devices: [],
      crumbs: [],
      meta: {},
      obj: null,
      model: {
        fields: {},
        items: {},
        obj: {},
      },
      updater: false,
      serviceBarEditMode: false,
      bar: {
        service: {
          edit: { open: false },
          update: { open: false },
        },
        device: { open: false },
      },
      files: [],
      filesEdit: false,
      equipmentTableUpdateCounter: 0,
      measure: null,
      dialog: {
        create: { show: false, files: [] },
        update: { show: false, files: [] },
        upload: { show: false, files: [] },
        edit: { open: false, obj: null },
        chart: { open: false },
        preferences: { open: false, param: null },
        rules: { open: false, row: null },
      },
      showMap: false,
    }
  },

  computed: {
    getSidebarActive(): string | null {
      return this.$store.state.devices.sidebar.active
    },

    getData(): DeviceItem | undefined {
      return this.$store.state.devices.treeActive[0]
    },

    getServiceBarEdit(): boolean {
      return this.bar.service.edit.open
    },

    getDeviceBarOpen(): boolean {
      const dev = this.$store.state.devices.activeDevice as ActiveDevice | null
      this.bar.device.open = !!(dev && dev.$id)
      return this.bar.device.open
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getDevices(): DeviceItem[] {
      return this.devices
    },

    getConnections(): any[] {
      return this.$store.getters.getConnections
    },

    getConnectionPlaces(): string[] {
      return this.connectionPlaces
    },

    getPlaces(): string[] {
      if (!this.checkPage('physical')) return []
      let places = this.$store.getters.getUI.events_journal 
        ? this.$store.getters.getPlaces.show.service 
        : this.$store.getters.getPlaces.show.service.filter((place: string) => place !== 'events')
      
      if (this.$store.state.auth.user?.level === 0) {
        return places
      } else {
        return places.filter((place: string) => place !== 'settings')
      }
    },

    getFiles(): FileItem[] {
      return this.files.filter(file => {
        return file.data?.description ? file.data.description.split('.').shift() !== 'image_$' : true
      })
    },

    ...mapGetters(['checkPage']),
  },

  watch: {
    '$store.state.devices.tree': {
      handler(newVal: DeviceItem[]): void {
        if (!newVal.length) return
        this.updater = true
        this.$nextTick(() => {
          this.updater = false
        })
        this.setup('WATCH SERVICE_PAGE tree')
      },
      deep: true
    },
    '$store.state.devices.activeDevice': {
      handler(newVal: ActiveDevice | null): void {
        if (!newVal) {
          this.bar.device.open = false
          return
        }
        this.bar.device.open = true
      },
      deep: true
    },
    getData: {
      handler(newVal: DeviceItem | undefined): void {
        if (!newVal) return
        this.bar.service.edit.open = false
        this.setup('WATCH SERVICE_PAGE getData')
      },
      deep: true
    },
    '$store.state.file.upload.counter': {
      handler(): void {
        this.loadFiles()
      },
      deep: true
    },
  },

  created(): void {
    console.log('SERVICE_PAGE', 'name', this.$options.name)
    this.setup('created')
  },

  methods: {
    async setup(caller: string): Promise<void> {
      console.log('SERVICE_PAGE', 'setup caller', caller)
      if (!this.getData) return
      this.loadDevices()

      this.showMap = false
      const exceptions = await this.$bridge.getTemplates(this.getData.cls, { id: this.getData.type })
      const hiddenFields = exceptions?.[0]?.hiddenFields
      
      if (hiddenFields?.length) {
        const result = hiddenFields.find((item: string) => item === 'area')
        console.log(result)
        this.mapType = result === undefined ? 'OL' : 'LEAF'
      } else {
        this.mapType = 'OL'
      }
    },

    async loadDevices(): Promise<void> {
      this.setLoader('loadDevices', true)

      if (this.$store.state.devices.treeActive[0]?._cmdb_) {
        this.obj = this.$store.state.devices.treeActive[0]
      } else {
        this.obj = await this.$bridge.getObjectById(this.$store.state.devices.treeActive[0]?.$id)
      }

      if (!this.obj) {
        this.setLoader('loadDevices', false)
        return
      }
      
      console.log('loadDevices', 'this.obj', this.obj)
      const data$ = await this.obj.getLinks?.({ compute: 'is_used' })
      this.devices = []

      if (data$?.length) {
        data$.forEach((child: DeviceItem) => {
          if (child.cls === 'device') {
            this.devices.push(child)
          }
        })
      }
      console.log('loadDevices', 'this.devices', this.devices)
      this.setLoader('loadDevices', false)
    },

    async loadFiles(): Promise<void> {
      if (!this.getData?.$id) return
      try {
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.getData.$id)
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async getEnums(cls: string): Promise<any[]> {
      try {
        const book$ = await this.$bridge.getEnum(cls)
        return book$ || []
      } catch (error) {
        console.error('CATCH', 'SERVICE_PAGE', 'getEnums', 'SMTH WRONG', error)
        return []
      }
    },

    async updateTree(): Promise<void> {
      try {
        console.log('SERVICE_PAGE', 'UPDATE_TREE')
        this.setLoader('updateTree', true)
        const $_obj = await this.$bridge.getObjectById(this.getData?.$id)
        console.log('SERVICE_PAGE', 'UPDATE_TREE $_obj', $_obj)
        
        if ($_obj) {
          if ($_obj.cls === 'device' && $_obj.tree_view) {
            console.log('SERVICE_PAGE', 'UPDATE_TREE', 'device no show')
            const parent = await $_obj.getParent?.()
            if (parent) {
              this.$store.dispatch('loadChildren', parent)
              this.$store.dispatch('activeTree', parent)
            } else {
              this.$store.dispatch('activeTree', $_obj)
            }
          } else if ($_obj.cls === 'folder' || $_obj.cls === 'service') {
            await this.$store.dispatch('loadTree')
            this.$store.dispatch('activeTree', $_obj)
            console.log('SERVICE_PAGE', 'UPDATE_TREE $_obj', $_obj)
          } else {
            this.$store.dispatch('loadChildren', $_obj)
            console.log('SERVICE_PAGE', 'UPDATE_TREE $_obj', $_obj)
            console.log('SERVICE_PAGE', 'UPDATE_TREE treeActive', this.$store.state.devices.treeActive[0])
          }
        }
        
        this.bar.service.edit.open = false
        await this.$store.dispatch('disposeDabLock', this.getData?.$id)
        this.$store.dispatch('setEditMode', false)
        this.setLoader('updateTree', false)
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', 'SERVICE_PAGE', 'updateTree', 'smth wrong', err)
        this.setLoader('updateTree', false)
        await this.$store.dispatch('disposeDabLock', this.getData?.$id)
        this.$store.dispatch('setEditMode', false)
      }
    },

    async updateDevice(payload: DeviceItem): Promise<void> {
      console.log('SERVICE_PAGE', 'updateDevice', 'payload', payload)
      console.log('SERVICE_PAGE', 'updateDevice', 'this.getData', this.getData)
      console.log('SERVICE_PAGE', 'updateDevice', 'this.getSidebarActive', this.getSidebarActive)
      await this.$store.dispatch('activeDevice', payload)
      this.updateTree()
      this.bar.service.edit.open = false
      await this.$store.dispatch('disposeDabLock', this.getData?.$id)
    },

    async onDeviceSelect(payload: string | DeviceItem): Promise<void> {
      console.log('onDeviceSelect', payload)
      const id = typeof payload === 'string' ? payload : payload.$id
      const device$ = await this.$bridge.getObjectById(id)
      console.log('onDeviceSelect', 'device$', device$)
      const children$ = await device$.getLinks?.({ compute: 'is_used' })
      device$.children = children$
      this.$store.dispatch('activeDevice', device$)
    },

    onFileAdd(payload: any): void {
      console.log('SERVICE_PAGE', 'onFileAdd', 'payload', payload)
      Object.keys(payload).forEach(index => {
        this.dialog.upload.files.push(payload[index])
      })
      this.dialog.upload.show = true
    },

    checkPlace(): boolean {
      const currentPlace = this.getPlaces[this.panel]
      return currentPlace === 'composition' || currentPlace === 'configuration'
    },

    onEdit(): void {
      if (this.getPlaces[this.panel] === 'configuration') {
        console.log('SERVICE_PAGE', 'onEdit', 'panel', this.getPlaces[this.panel])
        this.onConfigurationEdit(this.getData)
      } else {
        this.onServiceEdit()
      }
    },

    onServiceEdit(): void {
      this.bar.service.edit.open = !this.bar.service.edit.open
      this.serviceBarEditMode = true
      this.$store.dispatch('setEditMode', true)
    },

    onConfigurationEdit(val: DeviceItem | undefined): void {
      console.log('SERVICE_PAGE', 'onConfigurationEdit', val)
      if (!val) return
      this.dialog.edit.obj = val
      this.dialog.edit.open = true
    },

    onServiceEditClose(): void {
      this.bar.service.edit.open = false
      this.serviceBarEditMode = false
      this.$store.dispatch('setEditMode', false)
    },

    onDeviceBarClose(): void {
      this.$store.dispatch('activeDevice', null)
      this.$store.dispatch('setEditMode', false)
    },

    onFileEdit(): void {
      if (!this.files.length) return
      this.filesEdit = true
      this.dialog.upload.show = true
    },

    onFileDelete(id: string): void {
      this.dialog.upload.files.forEach((file, index) => {
        if (file.id === id) {
          this.dialog.upload.files.splice(index, 1)
        }
      })
      this.$bridge.deleteDocument(id)
      this.loadFiles()
    },

    onUpdater(): void {
      this.updater = true
      this.$nextTick(() => {
        this.updater = false
      })
    },

    onChartSelect(measure: any): void {
      if (!measure) return
      if (measure.mirror?.type === 'number') {
        this.measure = measure
        this.dialog.chart.open = !this.dialog.chart.open
      }
    },

    rulesOpen(rowData: any): void {
      if (this.$store.state.auth.user?.level === 0) {
        console.log('message filed!')
        console.log('rulesOpen', rowData)
        this.dialog.rules = { open: true, row: rowData }
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    onFileImportClose(): void {
      this.dialog.upload.show = false
      this.filesEdit = false
      this.dialog.upload.files = []
    },
  },
})
</script>

<style >

.crumbs {
  color: black;
}

.crumbs:hover {
  color: red;
  cursor: pointer;
}

.create-location {
  background-color: transparent;
}

.create-location:hover {
    color: red;
    cursor: pointer;
}


</style>
